module.exports = __WEBPACK_EXTERNAL_MODULE_tui_code_snippet__;